
import './contact.css';
import {useState} from 'react';
const Contact = () => {
  const [fullname, setFullName] = useState("");
  const [location, setLocation] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [email, setEmail] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [phone, setPhone] = useState("");
  return (
   <section id="contact">
 <div className='container'>
    <h2>Booking for 360 photo booth</h2>
    <form  action="https://formspree.io/f/mrgnpoyv"
  method="POST"> 
      <label>Booking Details</label>
      <input className='form-input'
        value={fullname}
        onChange={e => setFullName(e.target.value)}
        placeholder="FullName"
        type="text"
        name="fullname"
        required
      />
      <input className='form-input'
        value={location}
        onChange={e => setLocation(e.target.value)}
        placeholder="Your event Location"
        type="text"
        name="location"
        required
      />
       <h6>Your Event Date</h6>
       <input className='form-input'
        value={eventDate}
        onChange={e => setEventDate(e.target.value)}
        placeholder="Your event Date"
        type="date"
        name="eventDate"
        required
      />
       <h6>Device Type</h6>
      <select className='form-input' required value={deviceType} onChange={e => setDeviceType(e.target.value)}>
            <option value="small">66 cm Photo booth</option>
            <option value="big">115 cm Photo booth</option>
            <option value="both">Both 66 and 115 cm</option>
          </select>
      <input className='form-input'
        value={email}
        onChange={e => setEmail(e.target.value)}
        placeholder="Email address"
        type="email"
        name="email"
        required
      />
        <input className='form-input'
        value={phone}
        onChange={e => setPhone(e.target.value)}
        placeholder="Phone Number"
        type="number"
        name="phone"
        required
      />
     
      <button className='btn primary submit' type="submit">Submit</button>
    </form>
    </div>
     {/* <div className='pay'>
     <a className='btn success paynow' href='https://paystack.com/pay/DViews360'>Our Payment Page</a>
     </div> */}
   </section>
   
  )
}

export default Contact